export default "__VITE_ASSET__C9w_6XFM__"